<template>
  <div style="width: 500px">

    <!-- 编辑时显示-->
    <div class="recipe-info" v-if="status == 'edit' || status == 'detail'">
      <div class="info-item">
        <span>{{$t('lang.食谱编号')}}：</span>
        <span>{{ number }}</span>
      </div>

      <div class="info-item">
        <span>{{$t('lang.食谱版本号')}}：</span>
        <span>{{ modifyEdition }}</span>
      </div>
    </div>


    <el-form label-width="auto" :model="formData" ref="form" :hide-required-asterisk="disabled">
      <el-form-item :label="$t('lang.支持语言') + '：'" v-if="!disabled" style="width: 900px">
        <div style="display: flex;column-gap: 12px">
          <div class="lang-box">
            <el-checkbox-group v-model="selectLang">
              <el-checkbox :label="lang.value" v-for="lang in langList" :key="'lang_' + lang.value">
                {{ lang.name }}（{{ lang.value }}）
              </el-checkbox>
            </el-checkbox-group>
            <el-button type="primary" size="mini" @click="handleConfirmLang">{{$t('lang.确定')}}</el-button>
          </div>

          <div class="add-lang-row" @click="$refs.setSysLang.showDialog = true">
            <i class="el-icon-circle-plus" style="font-size: 32px" />
            <span>{{$t('lang.新增语言标识')}}</span>
          </div>
        </div>

      </el-form-item>

      <el-form-item :label="$t('lang.主语言') + '：'" prop="lang" style="width: 1000px" v-if="!disabled">
        <el-radio-group v-model="formData.lang" @change="handleChangeMainLang">
          <el-radio style="line-height: 40px" v-for="i in mainLangList" :key="'main_lang_' + i.value"
                    :label="i.value">{{ i.name }}（{{ i.value }}）
          </el-radio>
        </el-radio-group>

        <p class="tip">{{$t('lang.选择主语言后，在平台浏览多语言食谱时，该食谱会按照所选的主语言优先显示。建议所有食谱都选择同一个主语言并且选择常用语言方便查看。')}}</p>
      </el-form-item>

      <el-form-item :label="$t('lang.食谱类型') + '：'" prop="lang" style="width: 1000px"  v-if="!disabled" required>
        <el-radio-group v-model="formData.type" :disabled="disabledType" @change="handleChangeRecipeType">
          <el-radio style="line-height: 40px" label="SOUP">{{$t('lang.汤机')}}</el-radio>
          <el-radio style="line-height: 40px" label="AIR_FRYER">{{$t('lang.空炸')}}</el-radio>
          <el-radio style="line-height: 40px" label="SOUP_AND_AIR">{{$t('lang.汤机+空炸')}}</el-radio>
          <el-radio style="line-height: 40px" label="STAND_MIXER">{{$t('lang.厨师机')}}</el-radio>
          <el-radio style="line-height: 40px" label="SOUP_AND_STAND_MIXER">{{$t('lang.汤机+厨师机')}}</el-radio>
          <el-radio style="line-height: 40px" label="OVEN">{{$t('lang.烤箱')}}</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item :label="$t('lang.兼容型号')" required>
        <div class="form-check">
          <el-checkbox-group :disabled="disabled" v-model="formData.products">
            <el-checkbox :label="product.productCode" v-for="product in brandOwnerProductList" :key="product.productCode">{{product.productModel}}</el-checkbox>
          </el-checkbox-group>
        </div>
      </el-form-item>

      <el-form-item :label="$t('lang.食谱名称') + '：'" required>
        <template v-if="formData.supportLangList.length">
          <recipe-input v-model="recipeName" :list="formData.supportLangList" :lang="formData.lang" ref="nationInput" />
        </template>
      </el-form-item>

      <el-form-item :label="$t('lang.所属分类')" prop="recipeCategoryCode" v-show="formData.lang" required>
        <el-select :disabled="disabled" v-model="formData.recipeCategoryCode" :placeholder="$t('lang.请选择')">
          <el-option v-for="category in recipeCategory" :key="category.recipeCategoryCode" :label="category.name" :value="category.recipeCategoryCode"></el-option>
        </el-select>
        <el-link style="color: #2f86dd;margin-left: 14px" :underline="false" @click="$router.push('/category-set-add')" v-if="!disabled">
          {{ $t('lang.创建分类') }}</el-link>
      </el-form-item>

      <el-form-item :label="$t('lang.食谱图片') + '：'" prop="photo" required>
<!--        <el-upload-->
<!--            v-if="!disabled"-->
<!--            :action="api.upload"-->
<!--            :limit="1"-->
<!--            :data="{category: 'RECIPE'}"-->
<!--            :on-change="handleUploadFile"-->
<!--            :before-upload="handleBeforeUpload"-->
<!--            :on-remove="handleRemoveFile"-->
<!--            :file-list="imgList"-->
<!--            :class="{hide: isHideUpload}"-->
<!--            list-type="picture-card">-->
<!--          <i class="el-icon-plus"></i>-->
<!--          <div slot="tip" class="el-upload__tip" style="color: orangered;display: flex;flex-direction: column">-->
<!--            <span >{{$t('lang.文件大小不能超过300KB')}}</span>-->
<!--            <span>{{$t('lang.建议大小')}} 580 * 360</span>-->
<!--          </div>-->
<!--        </el-upload>-->

        <template v-if="formData.type">
          <image-upload
              :accept="photoFileType"
              v-model="formData.photo"
              :upload-data="{ category: 'RECIPE' }"
              :enable-crop="true"
              :crop-options="photoFileSize"
              :tip="photoFileTip"
              v-if="!disabled" />

          <el-image v-else style="width: 140px; height: 140px" :src="formData.photo | filterImg"></el-image>
        </template>
      </el-form-item>


      <el-form-item>
        <el-button @click="$router.back()" v-if="disabled">{{$t('lang.返回')}}</el-button>
        <template v-else>
          <el-button @click="$emit('save')">{{ $t('lang.保存') }}</el-button>
          <el-button v-if="$store.getters.hasTranslate" @click="$emit('translate')">{{$t('lang.翻译')}}</el-button>
        </template>
        <el-button type="primary" @click="$emit('next')">{{$t('lang.下一步')}}</el-button>
      </el-form-item>

    </el-form>

    <set-sys-lang ref="setSysLang" />
  </div>
</template>

<script>

import SetSysLang from "./SetSysLang";
import RecipeInput from "../recipe/RecipeInput";
import {handleFilterLang} from "@/utlis/utlis";
import {recipeCategoryList} from "@/js/common";
import ImageUpload from "@/components/image-upload/ImageUpload.vue";

export default {
  name: "RecipePhotoForm",
  components: {ImageUpload, RecipeInput, SetSysLang},
  props: {
    recipeData: {
      type: Object,
      default() {
        return {}
      }
    },
    status: {
      type: String,
      default: "add",
    },
    load: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      api: {
        upload: this.$api.file.upload,
        download: this.$api.file.download,
      },
      formData: {
        lang: '',
        photo: '',
        type:'',
        supportLangList: [],
        products: [],
        recipeCategoryCode: ''
      },

      selectLang: [],
      imgList: [],
      number: '',
      modifyEdition: '',
      disabled: false,
      recipeCategory: [],

      // 食谱名称
      recipeName: {},
      recipeLang: {},
    }
  },
  computed: {
    langList() { // 支持语言列表
      return handleFilterLang(this);
    },
    isHideUpload() {
      return this.formData.photo;
    },

    mainLangList() { // 选择语言列表
      let {supportLangList, lang} = this.$store.state.recipe;
      if(!Array.isArray(supportLangList)) return [];
      let langList = this.$store.state.supportLangList;
      let list = langList.filter(item => supportLangList.includes(item.value));
      let mainIndex = list.findIndex(item => item.value === lang);
      list.unshift(...list.splice(mainIndex, 1));
      return list;
    },

    // 如果有code禁用
    disabledType() {
      if(this.disabled) return true;
      const code = this.$store.state.recipe.code;
      return Boolean(code);
    },

    brandOwnerProductList() {
      return this.$store.getters.getProductModelByRecipeType;
    },

    // 图片格式
    photoFileType() {
      return ['AIR_FRYER', "STAND_MIXER"].includes(this.formData.type) ? "image/jpeg" : "image/*";
    },

    // 裁剪尺寸限制
    photoFileSize() {
      const {type} = this.formData;
      const defaultFixedNumber = [580, 360];
      const sizeMap = {
        "AIR_FRYER": [149, 115],
        "STAND_MIXER": [230, 150],
      }
      console.log("sizeMap[type]", sizeMap[type], type)
      return {
        fixed: false,
        fixedNumber: sizeMap[type] || defaultFixedNumber,
      }
    },

    // 裁剪尺寸tip
    photoFileTip() {
      const {type} = this.formData;
      const sizeMap = {
        "AIR_FRYER": [149, 115],
        "STAND_MIXER": [230, 150],
      }
      const defaultSize = [580, 360];
      const [width, height] = sizeMap[type] || defaultSize;
      return this.$t("lang.suggestedSizeWithLimit")
        .replace("{0}", width.toString())
        .replace("{1}", height.toString());
    }
  },
  watch: {
    load: {
      handler(val) {
        if (this.status != 'add' && val) {
          this.handleGetData();
        }
      },
      immediate: true,
      deep: true,
    },
    status: {
      handler(state) {
        if(state == 'detail') {
          this.disabled = true;
        }
      },
      immediate: true,
      deep: true,
    },
    formData: {
      handler(data) {
        this.$store.commit("CHANGE_RECIPE", data);
      },
      immediate: false,
      deep: true,
    },
    recipeName: {
      handler() {
        let recipeLang = this.handleFormatName();
        this.$store.commit("CHANGE_RECIPE", {recipeLang});
      },
      immediate: false,
      deep: true,
    },
    "$store.state.recipe.supportLangList": {
      handler(list) {
        this.selectLang = list;
        this.formData.supportLangList = list;
      }
    },
    "$store.state.recipe.recipeLang": {
      handler(val) {
        this.handleGetRecipeName(val);
      }
    }
  },
  async created() {
    if (this.status == 'add') {
      this.handleGetData();
    }
    this.$bus.$on("refreshRecipeCategory", async () => {
      this.recipeCategory = await recipeCategoryList(this, {lang: this.formData.lang});
    })

    this.$bus.$on("translateRecipe", () => {
      this.handleGetData();
    });
  },
  activated() {
    this.handleGetData();
  },
  methods: {
    // 切换食谱类型
    handleChangeRecipeType() {
      // 切换类型需要对已添加的步骤模式清空处理
      let {cookingStepList} = this.$store.state.recipe;
      // cookingStepList.forEach(item => item.workMode = null);
      cookingStepList = [];
      this.$store.commit("CHANGE_RECIPE", {cookingStepList});

      // 清除所选型号
      this.formData.products = [];

      // 清楚图片
      this.formData.photo = '';
    },

    // 格式化 食谱名称
    handleFormatName() {
      let recipeLang = this.recipeLang;
      // 先移除不存在的语言key;
      Object.keys(recipeLang).forEach(lang => {
        if (!this.formData.supportLangList.includes(lang)) {
          delete recipeLang[lang];
        }
      })
      let recipeNameKeys = Object.keys(recipeLang);
      for (const lang in this.recipeName) {
        if(recipeNameKeys.includes(lang)) {
          recipeLang[lang].name = this.recipeName[lang];
        } else {
          recipeLang[lang] = {
            name: this.recipeName[lang],
            introduction: ""
          }
        }
      }
      return recipeLang;
    },

    // 回显数据
    async handleGetData() {
      let {lang, recipeLang, photo, supportLangList, number, compatibleVersion,recipeCategoryCode,type, products} = this.$store.state.recipe;
      this.modifyEdition = compatibleVersion;
      this.number = number;
      this.handleGetRecipeName(recipeLang);

      this.recipeLang = recipeLang;

      let obj = {lang, photo,recipeCategoryCode,type};
      for (const key in obj) {
        if (obj[key]) {
          this.formData[key] = obj[key];
        }
      }
      this.formData.supportLangList = supportLangList || [];
      this.formData.products = products || [];
      this.selectLang = this.formData.supportLangList;
      this.recipeCategory = await recipeCategoryList(this, {lang: lang});
      if (photo) {
        this.imgList = [{url: this.api.download + '?fileCode=' + photo}];
      }
    },

    // 回显食谱名称
    handleGetRecipeName(recipeLang) {
      for (const lang in recipeLang) {
        this.$set(this.recipeName, lang, recipeLang[lang].name)
      }
    },

    //选择主语言
    async handleChangeMainLang(lang) {
      this.recipeCategory = await recipeCategoryList(this, {lang});
    },

    handleRemoveFile() {
      this.formData.photo = '';
    },

    // 文件上传前
    handleBeforeUpload(file) {
      if(file.size > 307200) {
        this.$message.warning(this.$t('lang.文件大小不能超过300KB'));
        return false;
      }
      return true;
    },

    handleUploadFile(file) {
      const vm = this;
      if (file.status == 'success') {
        let {response: res} = file;
        if (res.status != 200) {
          vm.$message.error(res.desc);
          return;
        }
        vm.formData.photo = res.data.fileCode;
        this.$refs.form.clearValidate('photo')
      }

    },

    // 选择支持语言
    handleConfirmLang() {
      this.formData.supportLangList = [...this.selectLang];

      // 设置主语言
      let {lang, supportLangList} = this.formData;
      if(lang && !supportLangList.includes(lang)) {
       this.formData.lang = "";
       this.$refs.nationInput.handleSetDefault();
      }

      // this.recipeName = handleFilterData(this.recipeName, "", this.formData.supportLangList);
    },
  },
  beforeDestroy() {
    this.$bus.$off("refreshRecipeCategory");
  },
}
</script>

<style scoped>

.recipe-info {
  width: 500px;
  background: #f9f9f9;
  border: 1px solid #dddddd;
  padding: 8px;
  display: flex;
  font-size: 14px;
  line-height: 26px;
  margin-bottom: 24px;
}

.recipe-info .info-item {
  margin-right: 14px;
}

.lang-box {
  width: 600px;
  background: #f9f9f9;
  border: 1px solid #dddddd;
  padding: 8px;
}


 /deep/ .hide .el-upload--picture-card  {
  display: none !important;
}

/deep/ .hide .el-upload--picture-card .el-upload-list__item {
  margin: 0;
}

/deep/ .el-upload-list__item {
  transition: none !important;
}

.tip {
  font-size: 12px;
  color: orangered;
  line-height: 20px;
}

.add-lang-row {
  width: max-content;
  display: flex;
  flex-direction: column;
  align-items: center;
}

</style>
